"use client";

import React from "react";
import "./PrivacyPolicy.scss";
import Link from "next/link";
import { ReactSVG } from "react-svg";

const PrivacyPolicy = () => {
  return (
    <div className='PrivacyPolicy-wrapper'>
      <div className='PrivacyPolicy-header-wrapper baseContainer'>
        <div className='maxWidth'>
          <div className='breadcrumbs-wrapper'>
            <Link
              href={"/"}
              className='text-xsmall-18 grey-100 weight-600'
              style={{ opacity: 0.5 }}>
              Home
            </Link>
            <ReactSVG src='/assets/next-arrow-small-ic.svg' />
            <p className='text-xsmall-18 white weight-700'>Privacy Policy</p>
          </div>
          <p className='section-main-header large white'>Privacy Policy</p>
        </div>
      </div>

      <div className='PloicyBody baseContainer'>
        <div className='maxWidth'>
          <div className='wrapper'>
            <div className='left'>
              <p className='text-medium-28  weight-600 black'>Content</p>
              <div className='links'>
                <Link href='/privacy-policy#1'>
                  <p className='text-mini-14 weight-500'>
                    Collecting Personal Information
                  </p>
                </Link>
                <Link href='/privacy-policy#2'>
                  <p className='text-mini-14 weight-500'>
                    Sharing Personal Information
                  </p>
                </Link>
                <Link href='/privacy-policy#3'>
                  <p className='text-mini-14 weight-500'>
                    Using Personal Information
                  </p>
                </Link>
                <Link href='/privacy-policy#4'>
                  <p className='text-mini-14 weight-500'>
                    Selling Personal Information
                  </p>
                </Link>
                <Link href='/privacy-policy#5'>
                  <p className='text-mini-14 weight-500'>Your rights</p>
                </Link>
                <Link href='/privacy-policy#6'>
                  <p className='text-mini-14 weight-500'>
                    Selling Personal Information
                  </p>
                </Link>
                <Link href='/privacy-policy#6'>
                  <p className='text-mini-14 weight-500'>Changes</p>
                </Link>
              </div>
            </div>
            <div className='right'>
              <div className='textBlock' id='1'>
                <div className='textWrapper'>
                  <p className='desc'>
                    This Privacy Policy describes how ToolSwift (the "Site" or
                    "we") collects, uses, and discloses your Personal Information
                    when you visit or make a purchase from the Site
                  </p>

                  <p className='title'>Collecting Personal Information</p>
                  <p className='desc'>
                    When you visit the Site, we collect certain information about
                    your device, your interaction with the Site, and information
                    necessary to process your purchases. We may also collect
                    additional information if you contact us for customer support.
                    In this Privacy Policy, we refer to any information that can
                    uniquely identify an individual (including the information
                    below) as "Personal Information". See the list below for more
                    information about what Personal Information we collect and
                    why.
                  </p>
                </div>
              </div>
              <div className='textBlock'>
                <div className='textWrapper'>
                  <p className='blue'>Device information</p>
                  <div className='desc'>
                    <ul>
                      <li>
                        <strong>
                          Examples of Personal Information collected:{" "}
                        </strong>{" "}
                        Version of web browser, IP address, time zone, cookie
                        information, what sites or products you view, search
                        terms, and how you interact with the Site.


                      </li>
                      <li>
                        <strong>Purpose of collection:</strong>To load the Site
                        accurately for you, and to perform analytics on Site usage
                        to optimize our Site.


                      </li>
                      <li>
                        <strong>Source of collection: </strong>
                        Collected automatically when you access our Site using
                        cookies, log files, web beacons, tags, or pixels.


                      </li>
                      <li>
                        <strong>Disclosure for a business purpose: </strong>{" "}
                        Shared with our processor ToolSwift.
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className='textBlock'>
                <div className='textWrapper'>
                  <p className='blue'>Order information</p>
                  <div className='desc'>
                    <ul>
                      <li>
                        <strong>Examples of Personal Information: </strong> Name,
                        billing address, shipping address, payment information
                        (including credit card numbers, email address, and phone
                        number.)


                      </li>
                      <li>
                        <strong>Purpose of collection:</strong> To provide
                        products or services to you to fulfill our contract, to
                        process your payment information, arrange for shipping,
                        and provide you with invoices and/or order confirmations,
                        communicate with you, screen our orders for potential risk
                        or fraud, and when in line with the preferences you have
                        shared with us, provide you with information or
                        advertising relating to our products or services.


                      </li>
                      <li>
                        <strong>Source of collection: </strong>
                        Collected from you.


                      </li>
                      <li>
                        <strong>Disclosure for a business purpose: </strong>{" "}
                        Shared with our processor ToolSwift.
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className='textBlock'>
                <div className='textWrapper'>
                  <p className='blue'>Customer support information</p>
                  <div className='desc'>
                    <ul>
                      <li>
                        <strong>
                          Examples of Personal Information collected:{" "}
                        </strong>{" "}
                        Details provided during support interactions.

                      </li>
                      <li>
                        <strong>Purpose of collection:</strong> To provide
                        customer support.


                      </li>
                      <li>
                        <strong>Source of collection: </strong>
                        Collected from you.


                      </li>
                      <li>
                        <strong>Disclosure for a business purpose: </strong>{" "}
                        Shared internally as necessary to provide service..
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className='textBlock' id='2'>
                <div className='textWrapper'>
                  <p className='title'>Sharing Personal Information</p>
                  <div className='desc'>
                    We share your Personal Information with service providers to
                    help us provide our services and fulfill our contracts with
                    you, as described above. For example:

                    <ul>
                      <li>
                        We use ToolSwift to power our online store. You can read
                        more about how ToolSwift uses your Personal Information on
                        their platform.
                      </li>
                      <li>
                        We may share your Personal Information to comply with
                        applicable laws and regulations, respond to a subpoena,
                        search warrant, or other lawful requests for information
                        we receive, or to protect our rights.
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className='textBlock'>
                <div className='textWrapper'>
                  <p className='desc black'>Behavioural Advertising</p>
                  <div className='desc'>
                    <ul>
                      <li>
                        As described above, we use your Personal Information to
                        provide you with targeted advertisements or marketing
                        communications we believe may be of interest to you. For
                        example:
                      </li>
                      <li>
                        We use Google Analytics to help us understand how our
                        customers use the Site. You can read more about how Google
                        uses your Personal Information here. You can also opt-out
                        of Google Analytics{" "}
                        <a
                          href='https://tools.google.com/dlpage/gaoptout'
                          target='_blank'
                          rel='noopener noreferrer'>
                          here
                        </a>
                        .
                      </li>
                      <li>
                        We share information about your use of the Site, your
                        purchases, and your interaction with our ads on other
                        websites with our advertising partners. We collect and
                        share some of this information directly with our
                        advertising partners, and in some cases through the use of
                        cookies or other similar technologies (which you may
                        consent to, depending on your location).
                      </li>
                      <li>
                        For more information about how targeted advertising works,
                        you can visit the Network{" "}
                        <a
                          href='https://thenai.org/about-online-advertising/faq/?tab=2'
                          target='_blank'
                          rel='noopener noreferrer'>
                          Advertising Initiative's ("NAI") educational page
                        </a>
                        .
                      </li>
                      <li>You can opt out of targeted advertising by:</li>

                      <li>
                        FACEBOOK - https://www.facebook.com/settings/?tab=ads
                      </li>
                      <li>
                        GOOGLE - https://www.google.com/settings/ads/anonymous
                      </li>
                      <li>
                        BING
                        - https://advertise.bingads.microsoft.com/en-us/resources/policies/personalized-ads]
                      </li>

                    </ul>
                    Additionally, you can opt out of some of these services by
                    visiting the Digital Advertising Alliance's opt-out portal.
                  </div>
                </div>
              </div>
              <div className='textBlock' id='3'>
                <div className='textWrapper'>
                  <p className='title'>Using Personal Information</p>
                  <p className='desc'>
                    We use your personal Information to provide our services to
                    you, which includes: offering products for sale, processing
                    payments, shipping and fulfillment of your order, and keeping
                    you up to date on new products, services, and offers.
                  </p>
                </div>
              </div>
              <div className='textBlock'>
                <div className='textWrapper'>
                  <p className='desc black'>Lawful basis</p>
                  <div className='desc'>
                    Pursuant to the General Data Protection Regulation ("GDPR"),
                    if you are a resident of the European Economic Area ("EEA"),
                    we process your personal information under the following
                    lawful bases:

                    <ul>
                      <li>Your consent;</li>
                      <li>
                        The performance of the contract between you and the Site;
                      </li>
                      <li>Compliance with our legal obligations;</li>
                      <li>To protect your vital interests;</li>
                      <li>
                        To perform a task carried out in the public interest;
                      </li>
                      <li>
                        For our legitimate interests, which do not override your
                        fundamental rights and freedoms.
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className='textBlock'>
                <div className='textWrapper'>
                  <p className='desc black'>Retention</p>
                  <p className='desc'>
                    When you place an order through the Site, we will retain your
                    Personal Information for our records unless and until you ask
                    us to erase this information. For more information on your
                    right of erasure, please see the 'Your rights' section below.
                  </p>
                </div>
              </div>
              <div className='textBlock'>
                <div className='textWrapper'>
                  <p className='desc black'>Automatic Decision-Making</p>
                  <p className='desc'>
                    If you are a resident of the EEA, you have the right to object
                    to processing based solely on automated decision-making (which
                    includes profiling) when that decision-making has a legal
                    effect on you or otherwise significantly affects you.

                    We do not engage in fully automated decision-making that has a
                    legal or otherwise significant effect using customer data.

                  </p>
                </div>
              </div>
              <div className='textBlock' id='4'>
                <div className='textWrapper'>
                  <p className='title'>Selling Personal Information</p>
                  <p className='desc'>
                    Our Site does not sell Personal Information, as defined by the
                    Consumer Privacy Act of 2024 ("CPA").
                  </p>

                  <div className='desc'>
                    <ul>
                      <li>Categories of information sold</li>
                      <li>Instructions on how to opt-out of sale</li>
                      <li>
                        Whether your business sells information of minors (under
                        16) and whether you obtain affirmative authorization
                      </li>
                      <li>
                        If you provide a financial incentive to not sell
                        information, provide information about what that incentive
                        is
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className='textBlock' id='5'>
                <div className='textWrapper'>
                  <p className='title'>Your rights</p>


                  <p className='desc black'>GDPR</p>
                  <p className='desc'>
                    If you are a resident of the EEA, you have the right to access
                    the Personal Information we hold about you, to port it to a
                    new service, and to ask that your Personal Information be
                    corrected, updated, or erased. If you would like to exercise
                    these rights, please contact us through the contact
                    information below.
                  </p>

                  <p className='desc black'>CPA</p>
                  <p className='desc'>
                    As a resident of Ontario, you have rights under the Consumer
                    Protection Act, including the right to access personal
                    information we hold about you, request corrections, and
                    opt-out of the sale of your data. To exercise these rights,
                    please contact us using the information below.
                  </p>

                </div>
              </div>
              <div className='textBlock' id='6'>
                <div className='textWrapper'>
                  <p className='title'>Cookies</p>
                  <p className='desc'>
                    We use a number of different cookies, including functional,
                    performance, advertising, and social media or content cookies.
                    Cookies make your browsing experience better by allowing the
                    website to remember your actions and preferences (such as
                    login and region selection).
                  </p>

                  <p className='desc black'>Cookies Types</p>
                  <p className='desc'>
                    Performance cookies track site performance, while Advertising
                    cookies are used to show relevant ads.
                  </p>

                  <p className='desc black'>Cookies Duration</p>
                  <p className='desc'>
                    Session cookies last as long as your browser is open, while
                    Persistent cookies can last up to two years.{" "}
                  </p>

                  <p className='desc black'>
                    Cookies Important for the Functioning of the Store
                  </p>
                  <p className='desc'>
                    authToken: Used in connection with access and authentication
                    to admin

                    For more details on cookies and how you can control them,
                    please refer to your browser's help function or visit
                    www.allaboutcookies.org.

                    ToolSwift uses cookies in accordance with applicable laws.
                    Depending on the country or jurisdiction you are located in,
                    ToolSwift may request your prior consent before using
                    non-essential cookies or provide you with the option to
                    opt-out of such cookies. These cookies help enhance your
                    experience on our Site and enable certain functionalities.

                    Your web browser may also allow you to manage cookie
                    preferences, including the ability to delete or disable
                    cookies, such as those used by Stripe for payment processing.
                    Please refer to the help section of your browser or follow the
                    provided links below for instructions on managing your cookie
                    settings. Be aware that disabling cookies may affect the
                    functionality of some features on our Site or services,
                    causing them not to operate as intended.\

                    Chrome: https://support.google.com/chrome/answer/95647?hl=en

                    Explorer:
                    https://support.microsoft.com/en-us/help/17442/windows-internet-explorer-delete-manage-cookies

                    Safari:
                    https://support.apple.com/guide/safari/manage-cookies-and-website-data-sfri11471/mac

                    Firefox:
                    https://support.mozilla.org/en-US/kb/cookies-information-websites-store-on-your-computer

                    Opera:
                    https://help.opera.com/en/latest/web-preferences/#cookies
                  </p>

                  <p className='desc black'>Do Not Track</p>
                  <p className='desc'>
                    Please note that because there is no consistent industry
                    understanding of how to respond to "Do Not Track" signals, we
                    do not alter our data collection and usage practices when we
                    detect such a signal from your browser.
                  </p>

                </div>
              </div>
              <div className='textBlock' id='7'>
                <div className='textWrapper'>
                  <p className='title'>Changes</p>
                  <p className='desc'>
                    We may update this Privacy Policy from time to time in order
                    to reflect, for example, changes to our practices or for other
                    operational, legal, or regulatory reasons.
                  </p>
                </div>
                <div className='textWrapper'>
                  <p className='desc black'>Contact </p>
                  <p className='desc'>
                    For more information about our privacy practices, if you have
                    questions, or if you would like to make a complaint, please
                    contact us by e-mail at{' '}
                    <Link
                      href="mailto:hello@amherstsupply.com"
                      className="text-medium-24 blue-500"
                      style={{ cursor: 'pointer' }}
                    >
                      hello@amherstsupply.com
                    </Link>
                    or by phone using the details provided below:

                    (519) 713-9318

                    1500 Alma Street, Amherstburg, ON N9V 2N9, Canada

                    Last updated: Sep. 24, 2024
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  );
};

export default PrivacyPolicy;
